module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "content_header"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('div', {
    staticClass: "sprite logo",
    staticStyle: {
      "display": "inline-block"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [(_vm.currentUser) ? _c('div', {
    staticClass: "search sprite Go_Out",
    attrs: {
      "title": "Logout"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.currentUser) ? _c('cart-icon') : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d4b2f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StsHeader.vue
// module id = 285
// module chunks = 1